import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import classnames from 'classnames'

import { closeModal } from '../../../reducers/modal'

// don't remove! needed to prevent flickering during animation in Safari..
const extraContent = (
  <button
    style={{
      visibility: 'hidden',
      background: 'none',
      padding: '0px',
      // Safari - flicker appears unless this element takes up some space,
      // but strangely enough doesnt work to set height+weight, but just border..
      // and transparent border doesnt work either, so use semi-transparent
      border: '0.5px solid rgba(255,255,255,0.01)',
      margin: '0px -2px 0px 0px',
      pointerEvents: 'none'
    }}
  />
)

const Modal = class Modal extends Component {
  componentDidUpdate (prevProps) {
    if (this.props.isActive && !prevProps.isActive) {
      document.body.classList.add('scrollblock--dialog')
    } else if (!this.props.isActive && prevProps.isActive) {
      document.body.classList.remove('scrollblock--dialog')
    }
  }
  render () {
    const { isActive, Content, closeModal, extraClass } = this.props

    if (!isActive) {
      return null
    }

    const classes = classnames(
      {
        'modal--active': isActive
      },
      'modal'
    )
    return (
      <div className={classes} role='dialog' onClick={closeModal}>
        {extraContent}
        <div
          className={classnames('modal__dialog', extraClass)}
          role='document'
          onClick={e => {
            e.nativeEvent.stopImmediatePropagation() // Prevent click bubbling and closing modal
            e.stopPropagation()
          }}
        >
          {Content && <Content key='content' closeModal={closeModal} />}
        </div>
      </div>
    )
  }
}

Modal.propTypes = {
  isActive: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  content: PropTypes.node,
  extraClass: PropTypes.string
}

const mapStateToProps = ({ modal: { isActive, content, extraClass } }) => {
  return { isActive, Content: content, extraClass }
}

export default connect(
  mapStateToProps,
  { closeModal }
)(Modal)
